import React, { useEffect, useState } from "react";
import {
  Container,
  Box,
  Tabs,
  Tab,
  Typography,
  CircularProgress,
} from "@mui/material";
import "./AdminPage.scss";
import StatsTab from "./tabs/StatsTab";
import UsersTab from "./tabs/UsersTab";
import { adminAuth } from "./AdminPageApi";

const TabPanel = ({ children, value, index, ...other }) => {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`admin-tabpanel-${index}`}
      aria-labelledby={`admin-tab-${index}`}
      {...other}
    >
      {value === index && <Box className="tab-panel-box">{children}</Box>}
    </div>
  );
};

const AdminPage = () => {
  const [tabIndex, setTabIndex] = useState(0);
  const [authorized, setAuthorized] = useState(null); // null = loading, true/false = result
  const [error, setError] = useState("");

  useEffect(() => {
    adminAuth(
      () => setAuthorized(true),
      () => {
        setAuthorized(false);
        setError("You are not authorized to view this page.");
      }
    );
  }, []);

  const handleTabChange = (_, newValue) => {
    setTabIndex(newValue);
  };

  if (authorized === null) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="40vh">
        <CircularProgress />
      </Box>
    );
  }

  if (!authorized) {
    return (
      <Container id="admin-page">
        <Typography variant="h5" color="error" align="center" mt={5}>
          {error}
        </Typography>
      </Container>
    );
  }

  return (
    <Container id="admin-page">
      <Tabs value={tabIndex} onChange={handleTabChange} className="admin-tabs">
        <Tab label="Book Availability" />
        <Tab label="Users" />
      </Tabs>

      <TabPanel value={tabIndex} index={0}>
        <StatsTab />
      </TabPanel>
      <TabPanel value={tabIndex} index={1}>
        <UsersTab />
      </TabPanel>
    </Container>
  );
};

export default AdminPage;
